
import {connect} from 'react-redux';
import axios from 'axios';
import { Platform} from "react-native";

import ListMyApplyOperationScreen from "../ListMyApplyOperationScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";

const mapStateToProps = (state) => ({
    //item_count: state.reducerSplashGetAllData.results.item_count,
    results: state.reducerListMyApplyOperationScreen.results,
    NoInternetDialog: state.reducerListMyApplyOperationScreen.NoInternetDialog,
    showLoading: state.reducerListMyApplyOperationScreen.showLoading,
    lazyload_end: state.reducerListMyApplyOperationScreen.lazyload_end,
    showRefresh: state.reducerListMyApplyOperationScreen.showRefresh,
    failed: state.reducerListMyApplyOperationScreen.failed,
    page: state.reducerListMyApplyOperationScreen.page,
    empty: state.reducerListMyApplyOperationScreen.empty,
    DataSplashScreen: state.reducerSplashGetAllData,
    // resultsSet: state.reducerListMyApplyOperationScreen.resultsSet,
    // isLoadingSet: state.reducerListMyApplyOperationScreen.isLoadingSet,
    // NoInternetDialogSet: state.reducerListMyApplyOperationScreen.NoInternetDialogSet,
    // id: state.reducerListMyApplyOperationScreen.id,
    // isLoadingSetSubmitRequestScreen: state.reducerSubmitRequestScreen.isLoadingSet,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id) => {
    let pagee;
    let url_send = "";

    //let u = "http://samanebehnood.com" + `/api/application/api/list/sliders/with/paginate` + params + `&i=${page}`;


    switch (type) {
        case typeExport.TypeGetListMyApplyOperationScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListMyApplyOperationScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();
    formData.append('_operation', typeExport._Shahrdar);
    // // formData.append('lang', params.lang);
    formData.append('mode', typeExport._GetTickets);
    formData.append('_session', params.token == null ? '' : params.token);
    formData.append('page', params.page);
    formData.append('typepm', params.typepm);
    formData.append('token_mahale', store.getState().reducerSplashGetAllData.tokenMahaleh);
    Tools.addAllFormData(formData,true);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        }
    };


    /*  axios(
          {
              // url: baseUrl + url + params,
              //url: url + "&after=0000-00-00",
              // url: url+`&${params.page}&${params.after}` ,
              url: url + params,
              // params:params,
              method: typeConnection,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
          }
      )*/
    axios.post(url, formData, config)
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetListMyApplyOperationScreen:


                    if (response.data.success) {


                        let data = response.data.result.list;

                      //  if (data == null) data = []
                        // let arr = store.getState().reducerListMyApplyOperationScreen.results
                        // if (page == 1) {
                        //     arr = data
                        // } else {
                        //     if (arr.length > 0)
                        //     //    arr.push(data);
                        //         arr = [...arr, ...data]
                        //     else
                        //         arr = data
                        // }

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee));
                        }
                        // else {
                        //     page === 1 ? dispatch(serviceActionEmptyListMyApplyOperationScreen(page)) : dispatch(serviceActionEndListMyApplyOperationScreen(page));

                        // }
                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee)));
                        }


                      //  await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApplyOperation +((getState === null || getState === undefined || getState === '') ? id : getState.route.params.item.type), arr)

                    } else {
                        alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetListMyApplyOperationScreen:
                    if (response.data.status)
                        dispatch(serviceActionSuccessSet(response.data, id))
                    else
                        alert(response.data.message)
                    break;
                default:
            }
        }).catch((e) => {
        switch (type) {
            case typeExport.TypeGetListMyApplyOperationScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListMyApplyOperationScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id) => {

    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //         if (isConnected) {

        //             getDataDisatch(dispatch, getState,url, params, type, typeConnection, page,item_count);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection", page));

        //         }
        //     }

        //     );
        // }
        // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState,url, params, type, typeConnection, page,item_count);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     });
        // }

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

                if (store.getState().reducerSplashGetAllData.Connection) {
                    getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
                } else {
                    switch (type) {
                        case typeExport.TypeGetListMyApplyOperationScreen:
                            dispatch(serviceActionError('error_Connection', page))

                            break;
                        case typeExport.TypeSetListMyApplyOperationScreen:
                            dispatch(serviceActionErrorSet('error_Connection'))
                            break;
                        default:
                    }
                }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListMyApplyOperationScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListMyApplyOperationScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListMyApplyOperationScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1
})
export const serviceActionSuccess = (data, page) => ({

    type: typeExport.ListMyApplyOperationScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page) => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListMyApplyOperationScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListMyApplyOperationScreen_SERVICE_AddSubList,

    data: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(ListMyApplyOperationScreen);
